import { z } from 'zod';
export const UserLanguageLevelSchema = z.object({
    id: z.number().optional(),
    language: z.string(),
    languageLevel: z.string()
});
//# sourceMappingURL=userLanguageLevelSchema.js.map